export enum PaymentPlanType {
  CREDITS = 'credits',
  INVOICE = 'invoice',
  TRIAL = 'trial',
  ADHOC = 'adhoc',
  FEE = 'fee'
}

export class PaymentPlan {
  id: string = null;
  name: string = null;

  planType: PaymentPlanType = null;

  amountPerCredit: number = null;

  // credit plans ONLY
  creditsPerMonth:number | undefined;
  amountPerMonth:number | undefined;

  // invoice plan ONLY
  minimumInvoiceAmount:number | undefined;

    constructor(p: Partial<PaymentPlan>) {
        Object.keys(this).forEach(key => {
            if (p[key] == null && this[key] == null)
                throw new Error(`${key} cannot be null.`);
        });
        Object.assign(this, p);
    }
}

